import { Component } from "preact";
import MessagePropagator from "../helper/message-propagator";

export default class OutsideLink extends Component {
    onClick(e) {
        e.preventDefault();
        MessagePropagator.postOpenExternalLink(this.props.href)
    }

    render() {
        return (
            <a onClick={this.onClick.bind(this)} href={this.props.href}>
                {this.props.content}
            </a>
        )
    }
}